import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e06b9cd")

_pushScopeId("data-v-6e06b9cd")
const _hoisted_1 = { class: "select-attribute" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "tile" }
const _hoisted_4 = { class: "checkbox-button not-select" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("details", {
      id: 'id_' + _ctx.attributeGroup.id,
      name: "headertitle",
      open: _ctx.isShowArea(_ctx.attributeGroup.id)
    }, [
      _createVNode("summary", _hoisted_2, _toDisplayString(_ctx.attributeGroup?.name), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("input", {
            type: "radio",
            id: _ctx.uuidValue,
            checked: _ctx.isNotSelected,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isNotSelected = $event.target.checked))
          }, null, 40, ["id", "checked"]),
          _createVNode("label", { for: _ctx.uuidValue }, "指定なし", 8, ["for"])
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attributeGroup.attributes, (attr) => {
          return (_openBlock(), _createBlock("div", {
            class: "checkbox-button",
            key: attr.id
          }, [
            _withDirectives(_createVNode("input", {
              type: "checkbox",
              id: `attrid_${attr.id}`,
              value: attr.id,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedList = $event))
            }, null, 8, ["id", "value"]), [
              [_vModelCheckbox, _ctx.selectedList]
            ]),
            _createVNode("label", {
              for: `attrid_${attr.id}`
            }, _toDisplayString(attr.name), 9, ["for"])
          ]))
        }), 128))
      ])
    ], 8, ["id", "open"])
  ]))
})